export default __webpack_public_path__ + "static/media/Orbitron-ExtraBold.87a7bd2e.ttf";